import LoginFrom from "../components/loginForm";

const LoginPage = () => {
  return <LoginFrom />;
};

export default LoginPage;